import * as React from 'react'
import MUITableBody from '@mui/material/TableBody'

const TableBody = (props) => <MUITableBody {...props} />

export default TableBody
